"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.average = void 0;
function average(numbers) {
    const total = numbers.reduce((acc, number) => acc + number, 0);
    return total / numbers.length;
}
exports.average = average;
//# sourceMappingURL=average.js.map